export default "__VITE_ASSET__Dq_3efW7__"